import { useLingui } from '@lingui/react/macro'
import { GraphStatus } from 'features/knowledgeDocumentViewer/graph/GraphStatus'
import type { ReactElement } from 'react'

export function PageImageStatus({
  pageNumber,
  retry,
}: {
  pageNumber: number
  retry: () => void
}): ReactElement {
  const { t } = useLingui()
  return (
    <GraphStatus
      message={t`Page ${pageNumber} could not be displayed`}
      failed
      retry={retry}
      placement='center'
      role='alert'
    />
  )
}
